import { render, staticRenderFns } from "./ShareLoadlist.vue?vue&type=template&id=8f5ba738"
import script from "./ShareLoadlist.vue?vue&type=script&lang=ts"
export * from "./ShareLoadlist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports